import { render, staticRenderFns } from "./TabReceived.vue?vue&type=template&id=0e4672dc&"
import script from "./TabReceived.vue?vue&type=script&lang=js&"
export * from "./TabReceived.vue?vue&type=script&lang=js&"
import style0 from "./TabReceived.vue?vue&type=style&index=0&id=0e4672dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports